import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.NudgeAction.HelpTooltip', {
    tooltipTitle: 'Nudge is unavailable due to one of the following:',
    tooltipItem1: 'Less than 24 hours since request creation',
    tooltipItem2: 'Less than 24 hours since review step completed',
    tooltipItem3: 'Less than 24 hours since last nudge',
});
